import { ASSET_ICON } from '../constants'
import type { BrandInfo, EmpresaPublica, VagaDetalhe } from '../types'
import { localStr, logoPlateClass, onImgError, proseLines } from '../utils'

interface JobDetailProps {
  detalhe: VagaDetalhe | null
  carregando: boolean
  brand: BrandInfo | null
  empresaSobre: string
  empresa: EmpresaPublica | null
  onCandidatar: () => void
  onVoltar: () => void
}

function Bullets({ texto }: { texto: string }) {
  const lines = proseLines(texto)
  if (lines.length <= 1) {
    return <p className="cr-prose">{texto}</p>
  }
  return (
    <ul className="cr-prose">
      {lines.map((l) => (
        <li key={l}>{l}</li>
      ))}
    </ul>
  )
}

export function JobDetail({
  detalhe,
  carregando,
  brand,
  empresaSobre,
  empresa,
  onCandidatar,
  onVoltar,
}: JobDetailProps) {
  if (carregando) {
    return <div className="cr-loading">Carregando vaga…</div>
  }

  if (!detalhe || !brand) {
    return (
      <div className="cr-card cr-detail-empty">
        <div className="cr-detail-placeholder">
          <span className="cr-emblem-plate cr-emblem-plate--md">
            <img src={ASSET_ICON} width={56} height={56} alt="" />
          </span>
          <h2>Vagas no Grupo HI</h2>
          <p className="cr-muted">Selecione uma vaga à esquerda para ver o detalhe e candidatar-se.</p>
        </div>
        {empresa?.apresentacao && (
          <>
            <h3>Apresentação da Empresa</h3>
            <p className="cr-prose">{empresa.apresentacao}</p>
          </>
        )}
      </div>
    )
  }

  const plate = logoPlateClass(brand.slug)
  const hard = detalhe.tags_tecnicas || []
  const soft = detalhe.tags_comportamentais || []
  const showRequisitos =
    !!detalhe.requisitos && !(hard.length || soft.length)

  return (
    <div
      className="cr-card"
      style={{
        ['--emp-cor' as string]: brand.cor_primaria,
        ['--emp-cor-2' as string]: brand.cor_secundaria || brand.cor_primaria,
      }}
    >
      <div className="cr-detail-brand">
        <span className={`cr-detail-brand-logo ${plate}`} aria-hidden="true">
          <img
            src={brand.logo_url}
            alt=""
            width={56}
            height={40}
            onError={onImgError(ASSET_ICON)}
          />
        </span>
        <div>
          <p className="cr-detail-brand-name">{brand.nome}</p>
          {brand.site_url && (
            <p className="cr-detail-brand-site">
              <a href={brand.site_url} target="_blank" rel="noopener noreferrer">
                {brand.site_url.replace(/^https?:\/\//i, '')}
              </a>
            </p>
          )}
        </div>
      </div>

      <div className="cr-detail-head">
        <h2>{detalhe.titulo}</h2>
        <p className="cr-loc">
          {brand.nome} — {localStr(detalhe)} · {detalhe.modalidade_display || detalhe.modalidade || ''}
        </p>
      </div>

      <h3>Apresentação da Empresa</h3>
      <p className="cr-prose">{empresaSobre}</p>

      {detalhe.descricao && (
        <>
          <h3>Principais Responsabilidades</h3>
          <Bullets texto={detalhe.descricao} />
        </>
      )}
      {showRequisitos && (
        <>
          <h3>Requisitos</h3>
          <Bullets texto={detalhe.requisitos!} />
        </>
      )}
      {hard.length > 0 && (
        <>
          <h3>Hard Skills</h3>
          <div className="cr-skills">
            {hard.map((t) => (
              <span key={t.nome} className="cr-skill hard">
                {t.nome}
              </span>
            ))}
          </div>
        </>
      )}
      {soft.length > 0 && (
        <>
          <h3>Soft Skills</h3>
          <div className="cr-skills">
            {soft.map((t) => (
              <span key={t.nome} className="cr-skill soft">
                {t.nome}
              </span>
            ))}
          </div>
        </>
      )}
      {detalhe.beneficios && (
        <>
          <h3>Benefícios</h3>
          <Bullets texto={detalhe.beneficios} />
        </>
      )}

      <p className="cr-muted" style={{ marginTop: 16 }}>
        Local do trabalho: <strong>{detalhe.modalidade_display || '—'}</strong>
        {detalhe.cargo_nome ? (
          <>
            {' '}
            · Cargo: <strong>{detalhe.cargo_nome}</strong>
          </>
        ) : null}
      </p>

      <div className="cr-actions">
        <button type="button" className="cr-btn cr-btn-accent" onClick={onCandidatar}>
          Candidatar-se
        </button>
        <button type="button" className="cr-btn cr-btn-ghost" onClick={onVoltar}>
          Voltar para os resultados
        </button>
      </div>
    </div>
  )
}
